var intellineticsICMS = (function () {
    //var redirectPopup;

    function loginToICMS() {
        var requestData = {
            token: $.session.Token,
            userId: $.session.UserId
        };

        $.ajax({
            type: 'POST',
            url: $.webServer.protocol + '://' + $.webServer.address + ':' + $.webServer.port + '/' + $.webServer.serviceName + '/loginToICMS/',
            data: JSON.stringify(requestData),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response, status, xhr) {
                data = response.loginToICMSResult;
                showIntellivueRedirectWarning();
                POPUP.hide(redirectPopup);
                window.open(response.loginToICMSResult, '_blank');
            },
        });
    }


    function openICMS(url) {

    }

    function showIntellivueRedirectWarning() {
        redirectPopup = POPUP.build({
            header: 'You are being redirected outside Anywhere to Intellivue. If you are using a popup blocker please make sure it is disabled.'
        });

        POPUP.show(redirectPopup);
    }

    return {
        loginToICMS
    }
})();